import React from 'react';
import { IoMdHome } from 'react-icons/io';
import { Link } from 'react-router-dom';

function Breadcrumb({ id }) {

    return (
        <nav aria-label="breadcrumb">
            <ol className="breadcrumb pl-0">
                <li className="breadcrumb-item"><Link to="/dashboard"><IoMdHome className='home' /> Home</Link></li>
                <li className="breadcrumb-item"><Link to="/admin-vendor-List">Vendors List</Link></li>
                <li className="breadcrumb-item"><Link to={{ pathname: "/admin-vendor-list-detail", state: { id: id } }}>Vendor Details</Link></li>
                <li className="breadcrumb-item active" aria-current="page">Edit Vendor Details</li>
            </ol>
        </nav>
    );
};

export default Breadcrumb;